import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css']
})
export class VehiclesComponent implements OnInit {

  constructor() { 
    firebase.database().ref("employee-location-data").set("gg");
  }

  ngOnInit() {
  }

  gridView = [
    {
        "Vehicle": "Image",
        "Maker": "Volvo",
        "Model": 2015,
        "Type": "Heavy Truck",
        "LicensePlate": "KA 01 MK 2008",
        "InService": "Yes"
    },
    {
      "Vehicle": "Image",
      "Maker": "Leyland",
      "Model": 2018,
      "Type": "Van",
      "LicensePlate": "KA 33 FG 3345",
      "InService": "No"
  },
  {
    "Vehicle": "Image",
    "Maker": "Mercedes",
    "Model": 2008,
    "Type": "Truck",
    "LicensePlate": "MK 08 MK 3456",
    "InService": "Yes"
},
{
  "Vehicle": "Image",
  "Maker": "Volvo",
  "Model": 2015,
  "Type": "Heavy Truck",
  "LicensePlate": "KA 01 MK 2008",
  "InService": "Yes"
},
{
  "Vehicle": "Image",
  "Maker": "Volvo",
  "Model": 2015,
  "Type": "Heavy Truck",
  "LicensePlate": "KA 01 MK 2008",
  "InService": "Yes"
},
{
  "Vehicle": "Image",
  "Maker": "Volvo",
  "Model": 2015,
  "Type": "Heavy Truck",
  "LicensePlate": "KA 01 MK 2008",
  "InService": "Yes"
},
{
"Vehicle": "Image",
"Maker": "Leyland",
"Model": 2018,
"Type": "Van",
"LicensePlate": "KA 33 FG 3345",
"InService": "No"
},
{
"Vehicle": "Image",
"Maker": "Mercedes",
"Model": 2008,
"Type": "Truck",
"LicensePlate": "MK 08 MK 3456",
"InService": "Yes"
},
{
"Vehicle": "Image",
"Maker": "Volvo",
"Model": 2015,
"Type": "Heavy Truck",
"LicensePlate": "KA 01 MK 2008",
"InService": "Yes"
},
{
"Vehicle": "Image",
"Maker": "Volvo",
"Model": 2015,
"Type": "Heavy Truck",
"LicensePlate": "KA 01 MK 2008",
"InService": "Yes"
},
{
  "Vehicle": "Image",
  "Maker": "Volvo",
  "Model": 2015,
  "Type": "Heavy Truck",
  "LicensePlate": "KA 01 MK 2008",
  "InService": "Yes"
},
{
"Vehicle": "Image",
"Maker": "Leyland",
"Model": 2018,
"Type": "Van",
"LicensePlate": "KA 33 FG 3345",
"InService": "No"
},
{
"Vehicle": "Image",
"Maker": "Mercedes",
"Model": 2008,
"Type": "Truck",
"LicensePlate": "MK 08 MK 3456",
"InService": "Yes"
},
{
"Vehicle": "Image",
"Maker": "Volvo",
"Model": 2015,
"Type": "Heavy Truck",
"LicensePlate": "KA 01 MK 2008",
"InService": "Yes"
},
{
"Vehicle": "Image",
"Maker": "Volvo",
"Model": 2015,
"Type": "Heavy Truck",
"LicensePlate": "KA 01 MK 2008",
"InService": "Yes"
}
  ]
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/fleet-management/vehicles/vehicles.component.ts